import React from "react";
import styled, { keyframes, css } from "styled-components";
import TransitionGroup from "react-transition-group/TransitionGroup";

export const Pages = styled(function Pages({ className, children }) {
  return (
    <article className={className}>
      <TransitionGroup className="Container">{children}</TransitionGroup>
    </article>
  );
})`
  box-sizing: border-box;
  display: block;
  flex: 1;
  overflow: hidden;
  position: relative;

  > .Container {
    display: block;
    height: 100%;
    width: 200%;
  }

  .Page {
    ${({ animation, duration = 0 }) => {
      switch (animation) {
        case "fade":
          return css`
            &.exited {
              float: right;
              margin-right: 50%;
              opacity: 0;
              z-index: 1;
            }
            &.entering {
              animation: ${pageTransitions.fade.in} ${duration}ms ease;
              animation-fill-mode: forwards;
              margin-right: -50%;
              float: left;
              z-index: 2;
            }
            &.entered {
              float: left;
              margin-right: -50%;
              opacity: 1;
              z-index: 2;
            }
            &.exiting {
              animation: ${pageTransitions.fade.out} ${duration}ms ease;
              animation-fill-mode: forwards;
              float: right;
              margin-right: 50%;
              z-index: 1;
            }
          `;
        case "slide":
          return css`
            &.exited {
              float: right;
              margin-left: -50%;
              z-index: 1;
            }
            &.entering {
              animation: ${pageTransitions.slide.in} ${duration}ms ease;
              animation-fill-mode: forwards;
              float: right;
              margin-left: -50%;
              z-index: 1;
            }
            &.entered {
              float: left;
              margin-right: -50%;
              z-index: 2;
            }
            &.exiting {
              animation: ${pageTransitions.slide.out} ${duration}ms ease;
              animation-fill-mode: forwards;
              float: left;
              margin-right: -50%;
              z-index: 2;
            }
          `;
        case "slideReverse":
          return css`
            &.exited {
              float: right;
              margin-left: -50%;
              z-index: 1;
            }
            &.entering {
              animation: ${pageTransitions.slideReverse.in} ${duration}ms ease;
              animation-fill-mode: forwards;
              float: left;
              margin-right: -50%;
              z-index: 2;
            }
            &.entered {
              float: left;
              margin-right: -50%;
              z-index: 2;
            }
            &.exiting {
              animation: ${pageTransitions.slideReverse.out} ${duration}ms ease;
              animation-fill-mode: forwards;
              float: right;
              margin-left: -50%;
              z-index: 1;
            }
          `;
        default: break;
      }
    }};
  }
`;

const pageTransitions = {
  fade: {
    in: keyframes`
      from { opacity: 0; }
      to { opacity: 1; }
    `,
    out: keyframes`
      from { opacity: 1; }
      to { opacity: 0; }
    `
  },
  slide: {
    in: keyframes`
      from { margin-right: 40%; }
      to { margin-right: 50%; }
    `,
    out: keyframes`
      from { margin-left: 0%; }
      to { margin-left: -50%; }
    `
  },
  slideReverse: {
    in: keyframes`
      from { margin-left: -50%; }
      to { margin-left: 0%; }
    `,
    out: keyframes`
      from { margin-right: 50%; }
      to { margin-right: 40%; }
    `
  },
};
export const PageContent = styled(function PageContent({
  state,
  className,
  ...props
}) {
  return <div className={`Page ${state} ${className}`} {...props} />;
})`
  background: #000;
  display: flex;
  height: 100%;
  position: relative;
  width: 50%;
`;



// WEBPACK FOOTER //
// ./src/components/AppPages/style.js